export default __webpack_public_path__ + "static/media/Yowai.b11e2c86.mp3";